// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Pin: 'pin',
	Lot: 'lot',
	UnitNo: 'unit-no',
	LevelNo: 'level-no',
	Plan: 'plan',
	LatestInstrument: 'latest-instrument',
	InputWrapper: 'input-wrapper',
	UnitTypeSelect: 'unit-type-select',
	ShowComparisonSwitch: 'show-comparison-switch',
	DescriptionTextArea: 'description-text-area',
	Option: 'option',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
